(function () {
  "use strict";

  if (window.__FH_CART_INTERCEPTOR_INSTALLED__) return;
  window.__FH_CART_INTERCEPTOR_INSTALLED__ = true;

  var DEBUG = !!(window.__FH_CFG__ && window.__FH_CFG__.debug);

  function log() {
    if (!DEBUG) return;
    try {
      var args = Array.prototype.slice.call(arguments);
      args.unshift("[FH Cart]");
      console.log.apply(console, args);
    } catch (e) {}
  }

  function getProps() {
    var p = window.__FH_CUSTOMIZER_PROPS__;
    if (!p || typeof p !== "object") return null;

    var clean = {};
    for (var k in p) {
      if (!Object.prototype.hasOwnProperty.call(p, k)) continue;
      var v = p[k];
      if (v === undefined || v === null) continue;
      if (typeof v === "string" && v.replace(/^\s+|\s+$/g, "") === "") continue;
      clean[k] = v;
    }
    for (var kk in clean) {
      if (Object.prototype.hasOwnProperty.call(clean, kk)) return clean;
    }
    return null;
  }

  function isCartAddAction(action) {
    var a = (action || "").toLowerCase();
    return a.indexOf("/cart/add") !== -1;
  }

  function addViaAjaxFromForm(form, props) {
    var fd = new FormData(form);
    var id = fd.get("id");
    if (!id) return Promise.reject(new Error("Form has no variant id (name='id')."));

    for (var k in props) {
      if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
      var v = props[k];
      fd.set("properties[" + k + "]", (typeof v === "string") ? v : JSON.stringify(v));
    }

    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Accept": "application/json" },
      body: fd,
      credentials: "same-origin"
    }).then(function (res) {
      if (!res.ok) {
        return res.text().catch(function () { return ""; }).then(function (text) {
          throw new Error("Add failed (" + res.status + "): " + text.slice(0, 300));
        });
      }
      return res.json().catch(function () { return {}; });
    });
  }

  function openCartNotification() {
    var notif =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-notification-drawer") ||
      document.getElementById("cart-notification") ||
      document.querySelector('[id*="cart-notification" i]');

    if (!notif) return Promise.resolve(false);

    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; })
      .then(function (cart) {
        if (cart && typeof notif.renderContents === "function") {
          try { notif.renderContents(cart); } catch (e) {}
        }
        if (typeof notif.open === "function") {
          try { notif.open(); return true; } catch (e2) {}
        }
        if (notif.tagName === "DETAILS") {
          notif.setAttribute("open", "open");
          return true;
        }
        try {
          notif.removeAttribute("aria-hidden");
          if (notif.classList) {
            notif.classList.add("active");
            notif.classList.add("is-active");
            notif.classList.add("open");
            notif.classList.add("is-open");
          }
        } catch (e3) {}
        return true;
      });
  }

  function stopEvent(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  }

  function interceptAdd(form, props) {
    log("Intercepted /cart/add with props:", Object.keys(props));
    return addViaAjaxFromForm(form, props)
      .then(function () { return openCartNotification(); })
      .then(function () {
        // Prevent props leaking to other products
        window.__FH_CUSTOMIZER_PROPS__ = null;
        return true;
      });
  }

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || form.tagName !== "FORM") return;

    var action = form.getAttribute("action") || "";
    if (!isCartAddAction(action)) return;

    // Optional: respect an "active" flag if you use it
    if (window.__FH_CUSTOMIZER_ACTIVE__ === false) return;

    var props = getProps();
    if (!props) return;

    stopEvent(e);

    interceptAdd(form, props).catch(function (err) {
      console.error("[FH Cart] intercept failed:", err);
      // Fallback to native submit so store isn't blocked
      try { form.submit(); } catch (_) {}
    });
  }, true);

  document.addEventListener("click", function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var btn = target.closest('button[type="submit"], input[type="submit"]');
    if (!btn) return;

    var form = btn.form;
    if (!form) return;

    var action = form.getAttribute("action") || "";
    if (!isCartAddAction(action)) return;

    if (window.__FH_CUSTOMIZER_ACTIVE__ === false) return;

    var props = getProps();
    if (!props) return;

    stopEvent(e);

    try {
      if (form.requestSubmit) form.requestSubmit(btn);
      else form.dispatchEvent(new Event("submit", { cancelable: true }));
    } catch (ex) {}
  }, true);

})();
